import React from "react";
import { Section, ToolbarButton } from "./UI";
import { LeadCard } from "./LeadCard";
import { useLeadFilters } from "../hooks/useLeadFilters";

export function LeadList({ leads, setView, startEdit, handleDelete, managerTg, role, loading }) {
  const {
    searchQuery,
    setSearchQuery,
    filters,
    setFilters,
    filteredLeads,
    filterOptions,
    resetFilters
  } = useLeadFilters(leads, managerTg, role);

  return (
    <Section
      title={`Мои лиды (${filteredLeads.length})`}
      right={
        <ToolbarButton onClick={() => setView("home")}>Назад</ToolbarButton>
      }
    >
      <div className="mb-3">
        <input 
          value={searchQuery} 
          onChange={(e) => setSearchQuery(e.target.value)} 
          placeholder="Поиск..." 
          className="w-full px-3 py-2 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:border-blue-500 dark:focus:border-blue-400 outline-none transition-colors" 
        />
      </div>
      <div className="grid md:grid-cols-3 gap-3 mb-4">
        <select 
          value={filters.event} 
          onChange={(e) => setFilters(f => ({ ...f, event: e.target.value }))} 
          className="px-3 py-2 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:border-blue-500 dark:focus:border-blue-400 outline-none transition-colors"
        >
          <option value="">Все ивенты</option>
          {filterOptions.events.map((ev) => (
            <option key={ev} value={ev}>{ev}</option>
          ))}
        </select>
        
        <select 
          value={filters.type} 
          onChange={(e) => setFilters(f => ({ ...f, type: e.target.value }))} 
          className="px-3 py-2 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:border-blue-500 dark:focus:border-blue-400 outline-none transition-colors"
        >
          <option value="">Все типы</option>
          {filterOptions.types.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
        
        <select 
          value={filters.works} 
          onChange={(e) => setFilters(f => ({ ...f, works: e.target.value }))} 
          className="px-3 py-2 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:border-blue-500 dark:focus:border-blue-400 outline-none transition-colors"
        >
          <option value="">Все статусы</option>
          <option value="yes">Уже с нами</option>
          <option value="no">Пока нет</option>
          <option value="unknown">Не уверен</option>
        </select>
      </div>
      
      <div className="grid md:grid-cols-3 gap-3 mb-4">
        <select 
          value={filters.cm} 
          onChange={(e) => setFilters(f => ({ ...f, cm: e.target.value }))} 
          className="px-3 py-2 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:border-blue-500 dark:focus:border-blue-400 outline-none transition-colors"
        >
          <option value="">Все модели комиссии</option>
          {filterOptions.commissionModels.map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
        
        <button 
          onClick={resetFilters} 
          className="px-3 py-2 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
        >
          Сбросить фильтры
        </button>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
            <p className="text-gray-600 dark:text-gray-400">Загрузка лидов...</p>
          </div>
        </div>
      ) : filteredLeads.length === 0 ? (
        <div className="text-gray-500 dark:text-gray-400">
          Лидов нет. Добавь нового: Меню → "Добавить лид".
        </div>
      ) : (
        <div className="grid gap-3">
          {filteredLeads.map((lead) => (
            <LeadCard 
              key={lead.id} 
              lead={lead} 
              onEdit={startEdit} 
              onDelete={handleDelete} 
            />
          ))}
        </div>
      )}
    </Section>
  );
}
